import type { UserType } from '@shared/index.js';

import type { UserIdentificationProperties } from '../analytics.types.ts';
import { convertUserType } from './convertUserType.js';

const parseUserType = (userType: UserType | null) => {
  const convertedUserType = convertUserType(userType);

  return { userType: convertedUserType };
};

export const parseIdentifyProperties = (properties?: UserIdentificationProperties) => {
  if (!properties) {
    return undefined;
  }

  return {
    ...properties,
    ...parseUserType(properties.userType),
  };
};
